import clsx from 'clsx';
import { UseEditSpendingWidgetArgs, useEditSpendingWidget } from './hooks';
import { IconButton } from '../Button';
import { Anchor } from '../ClickMenu';
import { EditSpendingModal } from './components';

interface EditSpendingWidgetProps extends UseEditSpendingWidgetArgs {
  className?: string;
}

export function EditSpendingWidget({ firmID, className, toFrequency, firmClientID }: EditSpendingWidgetProps) {
  const {
    getTitle,
    firmClient,
    spendingDisplay,
    lastUpdateDisplay,
    isEditSpendingModalOpen,
    setIsEditSpendingModalOpen,
  } = useEditSpendingWidget({ firmClientID, firmID, toFrequency });

  return (
    <Anchor
      placement="top"
      offset={[0, 8]}
      open={isEditSpendingModalOpen}
      setOpen={setIsEditSpendingModalOpen}
      popperJSPreventOverflowOptions={{ padding: 16 }}
      floatingElement={
        firmClient ? (
          <EditSpendingModal close={() => setIsEditSpendingModalOpen(false)} firmClient={firmClient} />
        ) : (
          <></>
        )
      }
    >
      <div
        className={clsx(
          className,
          'bg-palette-600/20 rounded-2xl grid grid-cols-[1fr_auto] sm:grid-cols-[auto_1fr_auto] grid-flow-row sm:grid-flow-col p-6 items-center'
        )}
      >
        <p className="text-darkMode-gray-medium mix-blend-plus-lighter text-xl leading-5 tracking-[-0.4px] font-medium mr-auto whitespace-normal mb-4 sm:mb-0 sm:whitespace-pre-line col-span-2 sm:col-span-1">
          {getTitle()}
        </p>
        <div className="flex flex-col mr-4">
          <p className="text-left sm:text-right text-white text-3xl font-bold leading-[30px]">{spendingDisplay}</p>
          {lastUpdateDisplay && (
            <p className="text-left sm:text-right mix-blend-plus-lighter text-darkMode-gray-medium leading-[normal] text-[13px]">
              {lastUpdateDisplay}
            </p>
          )}
        </div>
        <IconButton
          icon="create"
          diameter={40}
          theme="secondary"
          disabled={!firmClient}
          className="ml-auto sm:ml-0"
          onClick={() => setIsEditSpendingModalOpen(true)}
        />
      </div>
    </Anchor>
  );
}
